import { connect } from 'react-redux';
import { getFeeTypesBegin, getInvoiceTypesBegin } from '../../store/actions/accounting.actions';
import { getPersonContactsBegin } from '../../store/actions/person.actions';
import { getFeeTypes, getInvoiceTypes, getInvoiceTypesLoading } from '../../store/selectors/accounting.selectors';
import { getPersonContactLoader, getPersonContacts } from '../../store/selectors/person.selectors';
import NewInvoiceDialog from './NewInvoiceDialog';

const mapStateToProps = (state: any) => ({
    invoiceTypes: getInvoiceTypes(state),
    invoiceTypesLoading: getInvoiceTypesLoading(state),
    feeTypes: getFeeTypes(state),
    contacts: getPersonContacts(state),
    contactsLoading: getPersonContactLoader(state),
});

const mapDispatchToProps = {
    getInvoiceTypes: getInvoiceTypesBegin,
    getFeeTypes: getFeeTypesBegin,
    getContacts: getPersonContactsBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewInvoiceDialog);
